import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default function useQuery() {
  const { search } = useLocation();

  return useMemo(
    () =>
      new Proxy(new URLSearchParams(search), {
        get: (searchParams: any, prop: any) => searchParams.get(prop),
      }),
    [search],
  );
}
